import React from 'react';
import ApplicationFormType from './application-form-type'
export default(props)=>{
  return(
    <ApplicationFormType {...props}/>
  )
}


  
